import { NgModule } from '@angular/core';
import { CoreUiModule } from 'webcommon/core-ui';
import { MacroModule } from 'webcommon/macro';

import {
  ApHtmlTextEditorComponent,
} from './html-text-editor';

import {
  ApHtmlTextEditorWithMacrosComponent,
} from './html-text-editor-with-macros';

import {
  ApStandaloneHtmlEditorWithMacrosModalComponent,
} from './components';

const exportComponents = [
  ApHtmlTextEditorComponent,
  ApHtmlTextEditorWithMacrosComponent,
  ApStandaloneHtmlEditorWithMacrosModalComponent,
];

const declareComponents = [
  ...exportComponents,
];

@NgModule({
  declarations: [
    declareComponents,
  ],
  exports: [
    exportComponents,
  ],
  imports: [
    CoreUiModule,
    MacroModule,
  ],
})
export class HtmlEditorModule {
}
